import { format } from "date-fns";

export const deploy = process.env["VUE_APP_RELEASEDATE"] || "";

const deployInfo = deploy.split(" :: ");
export const date = deployInfo.slice(1, 2).shift();
export const hash = deployInfo.pop();

// 2021-08-10 16:18 bugsnag formatting

export const releaseDate = date
	? format(new Date(date), "yyyy-MM-d HH:mm")
	: "";
export const releaseHash = hash.replace("sha", "").slice(0, 8);
